import axios, { AxiosRequestConfig } from "axios";
import store from "../vuex/store";
import { OnlineNewsDTO } from "@/model/component.model";
import { EmailRegistrationDTO } from "@/model/data.model";

export class EmailRegistration {
  getEmailsList() {
    const config = {
      method: "GET",
      url:
        store.getters.BASE_API_URL +
        `/customers/${store.getters["customer/customerMbeId"]}/username/${store.getters.user.username}/mol-shipments-email`
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data as EmailRegistrationDTO[];
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  deleteEmail(email: string) {
    const config = {
      method: "DELETE",
      url:
        store.getters.BASE_API_URL +
        `/customers/${store.getters["customer/customerMbeId"]}/username/${store.getters.user.username}/mol-shipments-email`,
      params: {
        email
      }
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data as EmailRegistrationDTO;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  createEmailData(data: EmailRegistrationDTO) {
    const config = {
      method: "POST",
      url:
        store.getters.BASE_API_URL +
        `/customers/${store.getters["customer/customerMbeId"]}/username/${store.getters.user.username}/mol-shipments-email`,
      data
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data as EmailRegistrationDTO;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }

  updateEmailData(data: EmailRegistrationDTO) {
    const config = {
      method: "PUT",
      url:
        store.getters.BASE_API_URL +
        `/customers/${store.getters["customer/customerMbeId"]}/username/${store.getters.user.username}/mol-shipments-email`,
      data
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data as EmailRegistrationDTO;
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
